/**
 *
 * Asynchronously loads the component for DevControlPanel
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/DevControlPanel/loadable.js